"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileUpdatedData = void 0;
var runtypes_1 = require("runtypes");
var runtypeImplementing_1 = require("../../../util/runtypeImplementing");
var UUID_1 = require("../../../util/UUID");
var Data_1 = require("./Data");
exports.ProfileUpdatedData = (0, runtypeImplementing_1.runtypeImplementing)(Data_1.Data)((0, runtypes_1.Record)({
    type: (0, runtypes_1.Literal)("profileUpdated"),
    profile: UUID_1.UUID,
    // Numeric timestamp as string.
    updatedAt: runtypes_1.String,
}));
//# sourceMappingURL=ProfileUpdatedData.js.map